module.exports = __webpack_public_path__ + "static/img/2017122713484850.6330ad4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2017122713484850.jpg
// module id = vfQ/
// module chunks = 0